import { analyticsService } from './analytics-service';

export const logContactClick = (section: string, label: string) => {
  analyticsService.log('contact_button_click', { section, label });
};

export const logServicesClick = (section: string, label: string) => {
  analyticsService.log('services_button_click', { section, label });
};

export const logOpenFaqQuestion = (question: string) => {
  analyticsService.log('faq_open_question', { question });
};

export const logServicesDialogOpen = (service: string) => {
  analyticsService.log('services_open_dialog', { service });
};

export const logContactPopupOpen = () => {
  analyticsService.log('contact_open_popup');
};
